import { render, staticRenderFns } from "./yi_button.vue?vue&type=template&id=63c0234c&scoped=true&"
import script from "./yi_button.vue?vue&type=script&lang=js&"
export * from "./yi_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c0234c",
  null
  
)

export default component.exports